export class SupervisionRequest{    
    public supervisionName: string;
}